export default "__VITE_ASSET__DDoclpgv__"